import HolidayListing from "@/Component/Module/HolidayListing";
import SeoHead from "@/Component/Seo/SeoHead";
import { serverFetchHolidayListPageHeading } from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import { normalizeListPageHeading } from "@/utils/homePageHelpers";
import { fetchPageSeo } from "@/utils/pageSeo";

export default function HolidayListPage({
  seo,
  seoCountry,
  initialListPageHeading,
}) {
  return (
    <>
      <SeoHead
        seo={seo}
        country={seoCountry}
        fallbackTitle="Holiday Packages | Next Holidays"
      />
      <HolidayListing initialListPageHeading={initialListPageHeading} />
    </>
  );
}

export async function getServerSideProps(context) {
  const country = getCountryFromContext(context);
  const seoResult = await fetchPageSeo(context);
  if (seoResult.redirect) return seoResult;

  try {
    const listPageHeading = await serverFetchHolidayListPageHeading(country);

    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialListPageHeading: normalizeListPageHeading(listPageHeading),
      },
    };
  } catch (error) {
    console.error("Holiday list page SSR error:", error);
    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialListPageHeading: null,
      },
    };
  }
}
